import React from 'react'

import { B5, SH3, Stack, XStack } from '@zet/design-system'
import { handleCardIconColorText } from '@zet/feature-earnings/src/utils'
import moment from 'moment'

type Props = {
  name: string
  partnerName: string
  transactionDate: string
  status: string
  amount: number
}

const EarningsCardSection = (props: Props) => {
  const { name, partnerName, transactionDate, status, amount } = props
  return (
    <XStack className="justify-between px-3 pb-3">
      <Stack>
        <SH3 className="text-primary-150">{name}</SH3>
        <B5 className="text-grays-70 leading-6">{partnerName}</B5>
        {Boolean(transactionDate) && (
          <B5 className="text-grays-70 leading-4">
            {moment(transactionDate, 'YYYY-MM-DD').format('DD-MMM-yyyy')}
          </B5>
        )}
      </Stack>
      <Stack className="justify-center">
        <XStack className="items-center self-end">
          {handleCardIconColorText(status).icon}
          <SH3
            style={{
              color: handleCardIconColorText(status).textColor,
            }}
            className="ml-1"
          >
            {amount && parseFloat(amount.toFixed(2))}
          </SH3>
        </XStack>
        <B5 className="text-grays-70 text-right">
          {handleCardIconColorText(status).text}
        </B5>
      </Stack>
    </XStack>
  )
}

export default EarningsCardSection
